const normalizeWhatsappPhone = (value?: string): string | null => {
	if (typeof value !== "string") return null;
	const digitsOnly = value.replace(/\D/g, "").trim();
	return digitsOnly.length > 0 ? digitsOnly : null;
};

export const SUPPORT_WHATSAPP_REPORT_NUMBER = normalizeWhatsappPhone(
	import.meta.env?.VITE_SUPPORT_WHATSAPP_REPORT_NUMBER,
);

export function buildSupportWhatsAppReportUrl(message?: string): string | null {
	if (!SUPPORT_WHATSAPP_REPORT_NUMBER) return null;
	const text = typeof message === "string" ? message.trim() : "";
	const query = text.length > 0 ? `?text=${encodeURIComponent(text)}` : "";
	return `https://wa.me/${SUPPORT_WHATSAPP_REPORT_NUMBER}${query}`;
}
